export default "/fonts/Fontfabric - UniNeueBold.otf?0adb4fc9be3232aafd553d6df4e7e0f0";